import { AppError } from "./error/app";
import { EVM_NETWORKS, Network, SUPPORTED_NETWORKS } from "./network";
import { normalizeAddress } from "./nft";
import { REGEX_EVM_ADDRESS, REGEX_SOL_ADDRESS } from "./regex";
import { toJSON, walletAddressPreview } from "./utils";
export var WalletError;
(function (WalletError) {
    WalletError["INVALID_WALLET"] = "invalid_wallet_address";
    WalletError["WALLET_INUSE"] = "wallet_in_use";
    WalletError["UNKNOWN_ERROR"] = "unknown_error";
})(WalletError || (WalletError = {}));
export var WalletProvider;
(function (WalletProvider) {
    WalletProvider["WEB3AUTH"] = "web3auth";
    WalletProvider["PARTICLE_NETWORK"] = "particle_network";
    WalletProvider["MAGIC_LINK"] = "magic_link";
})(WalletProvider || (WalletProvider = {}));
export const DEFAULT_WALLET_PROVIDER = WalletProvider.PARTICLE_NETWORK;
export class Wallet {
    constructor(params) {
        this.network = EVM_NETWORKS.includes(params.network)
            ? Network.EVM
            : params.network;
        this.address = normalizeAddress(this.network, params.address);
        this.connectedAt = Number(params.connectedAt || new Date().valueOf());
        this.nickname = params.nickname || "";
        this.verified = !!params.verified;
        this.disconnected = !!params.disconnected;
        if (params.provider) {
            this.provider = params.provider;
        }
        else if (params.web3auth) {
            this.provider = WalletProvider.WEB3AUTH;
        }
    }
    get json() {
        return toJSON(this);
    }
    get addressPreview() {
        return walletAddressPreview(this.address);
    }
}
export const isEVMAddress = (address) => {
    return REGEX_EVM_ADDRESS.test(address);
};
export const isSolanaAddress = (address) => {
    return REGEX_SOL_ADDRESS.test(address);
};
export const isValidAddress = (address) => {
    return isEVMAddress(address) || isSolanaAddress(address);
};
export const validateWalletAddress = (network, address) => {
    if (!SUPPORTED_NETWORKS.includes(network))
        throw AppError.UNSUPPORTED_NETWORK;
    let valid = false;
    if (network == Network.SOLANA) {
        if (REGEX_SOL_ADDRESS.test(address))
            valid = true;
    }
    else if (EVM_NETWORKS.includes(network)) {
        if (REGEX_EVM_ADDRESS.test(address))
            valid = true;
    }
    if (!valid)
        throw WalletError.INVALID_WALLET;
    return true;
};
